import React, { useEffect, useState } from 'react';
import { Loader2, Bell, CheckCircle2, AlertTriangle } from 'lucide-react';
import { clientApi, formatDate } from '../../components/client-portal/clientPortalApi';

export default function ClientNotifications() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = async () => setItems(await clientApi('/client/notifications'));

  useEffect(() => {
    (async () => {
      try { await reload(); } finally { setLoading(false); }
    })();
  }, []);

  const markRead = async (id) => {
    await clientApi(`/client/notifications/${id}/read`, { method: 'PATCH' });
    setItems((prev) => prev.map((n) => (n.id === id ? { ...n, read: true } : n)));
  };

  if (loading) return <div className="flex justify-center py-24"><Loader2 className="w-6 h-6 animate-spin text-slate-400" /></div>;

  return (
    <div className="space-y-4" data-testid="client-notifications">
      <h1 className="text-2xl sm:text-3xl font-semibold text-slate-900">Updates</h1>
      {items.length === 0 && (
        <div className="rounded-2xl bg-white ring-1 ring-slate-200 p-8 text-center text-slate-500">
          <Bell className="w-10 h-10 mx-auto text-slate-300" />
          <div className="mt-3">No updates yet.</div>
        </div>
      )}
      <ul className="space-y-2">
        {items.map((n) => (
          <li
            key={n.id}
            data-testid={`notif-${n.id}`}
            className={`rounded-xl ring-1 p-4 transition ${n.read ? 'bg-white ring-slate-200' : 'bg-emerald-50/40 ring-emerald-200'}`}
          >
            <div className="flex items-start gap-3">
              <span className={`w-9 h-9 rounded-full flex items-center justify-center flex-none ${
                n.type === 'success' ? 'bg-emerald-100 text-emerald-600' :
                n.type === 'action' ? 'bg-amber-100 text-amber-600' :
                n.type === 'warning' ? 'bg-rose-100 text-rose-600' :
                'bg-sky-100 text-sky-600'
              }`}>
                {n.type === 'success' ? <CheckCircle2 className="w-4 h-4" /> :
                 n.type === 'warning' || n.type === 'action' ? <AlertTriangle className="w-4 h-4" /> :
                 <Bell className="w-4 h-4" />}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2 flex-wrap">
                  <div className="font-semibold text-slate-900">{n.title}</div>
                  <span className="text-xs text-slate-400">{formatDate(n.created_at)}</span>
                </div>
                <div className="text-slate-600 text-sm mt-0.5">{n.body}</div>
                {!n.read && (
                  <button
                    onClick={() => markRead(n.id)}
                    className="mt-2 text-xs text-emerald-700 hover:underline"
                  >
                    Mark as read
                  </button>
                )}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
